//@ts-check
//@ts-ignore
import PcRegister from './pc-register.riot';
import { connect } from '@/common/lib/riot-redux';
import { pcRegisterFailure, pcRegisterRequest, pcRegisterSuccess } from './pc.action';
import { router } from '@riotjs/route';
import { ajaxPost } from '../ajax';

const mapStateToProps = (state, props) => ({
  officeId: props.officeId,
  apiKey: props.apiKey
});

const mapDispatchToProps = (dispatch) => ({
  async pcRegister(data) {
    dispatch(pcRegisterRequest());
    try {
      const res = ajaxPost('/vpmain', {
        method: 'register',
        hwKey: sessionStorage.getItem('hwKey'),
        ...data
      });
      dispatch(pcRegisterSuccess(res));
      router.push(`pc/check?officeId=${data.officeId}&apiKey=${data.apiKey}`);
    } catch (e) {
      dispatch(pcRegisterFailure(e));
    }
  }
});
export default connect(PcRegister, mapStateToProps, mapDispatchToProps);